import { render } from "./TheVideoViewer.vue?vue&type=template&id=20d90480&scoped=true&ts=true"
import script from "./TheVideoViewer.vue?vue&type=script&lang=ts"
export * from "./TheVideoViewer.vue?vue&type=script&lang=ts"

import "./TheVideoViewer.vue?vue&type=style&index=0&id=20d90480&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d90480"]])

export default __exports__